<template lang="html">
  <div class="full-height-page">
    <v-layout
      class="py-3"
      v-if="!taxReturn || !pageImages"
      align-center
      justify-center
    >
      <sc-small> Loading filing instructions... </sc-small>
    </v-layout>

    <div v-else-if="taxReturn.filing_instructions">
      <div class="px-3 pt-3">
        <sc-h4>
          Filing Instructions
        </sc-h4>
      </div>

      <div v-for="{ page } in taxReturn.filing_instructions">
        <img
          v-if="pageImages.find(i => i.page === page)"
          :src="pageImages.find(i => i.page === page).thumbnail"
          class="page"
        />
      </div>
    </div>

    <v-layout v-else class="py-3" align-center justify-center>
      <sc-small> No filing instructions to show. </sc-small>
    </v-layout>
  </div>
</template>

<script>
import API from '@/api';
import { generatePdfThumbnails } from '@/utils/pdf';
import { PDFDocument } from 'pdf-lib';

export default {
  data() {
    return {
      taxReturn: null,
      pageImages: null,
    };
  },

  methods: {
    async getTaxReturn() {
      // get tax return id from params
      const taxReturnId = this.$route.query.taxReturnId;
      const companyId = this.$route.query.companyId;

      try {
        const response = await API.taxReturn.getTaxReturn({
          id: taxReturnId,
          companyId,
        });

        this.taxReturn = response.data;
      } catch (error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem loading filing instructions.',
        });
      }
    },

    async loadPageImages() {
      const response = await API.integration.downloadDocument({
        companyId: this.taxReturn.company_id,
        link: this.taxReturn.original_file,
      });

      const pdfSrc = response.data.document.data.link;
      const pdfBytes = await fetch(pdfSrc).then(res => res.arrayBuffer());

      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pdfData = await pdfDoc.saveAsBase64({ dataUri: true });
      this.pageImages = await generatePdfThumbnails(pdfData, 1000);
    },
  },

  async created() {
    await this.getTaxReturn();
    await this.loadPageImages();
  },
};
</script>

<style lang="css" scoped>
.full-height-page {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  overflow: auto;
  background-color: #eee;
}

.page {
  width: 100%;
  max-width: 1000px;
  padding: 16px;
}
</style>
